import React from 'react';
import I18n from 'i18n-js';
import ShowSlideshowCheckbox from '@/components/shared/NewLessonOverview/ShowSlideshowCheckbox';
import styles from './SaveLocation.module.scss';
import mySlideshowsTab from '../../../../../../images/my-slideshows.png';

type SaveLocationProps = {
  isInNewLessonOverview: boolean;
};

const SaveLocation = ({ isInNewLessonOverview = false }: SaveLocationProps) => {
  const message = isInNewLessonOverview
    ? I18n.t('view_saved_slideshows_message')
    : I18n.t('view_saved_presentations_message');

  return (
    <div>
      <hr className={styles.divider} />
      <p>
        {message}
      </p>
      <div className={styles.imgContainer}>
        {isInNewLessonOverview ? (
          <ShowSlideshowCheckbox
            isChecked
            isInEditModal
            handleCheckboxChange={() => {}}
          />
        ) : (
          <img
            alt="Slideshow location tab"
            className={styles.slideshowsTab}
            src={mySlideshowsTab}
          />
        )}
      </div>
    </div>
  );
};

export default SaveLocation;
